export type RadioRowProps = {
  label: string;
  active: boolean;
  onClick: () => void;
};

export function RadioRow({ label, active, onClick }: RadioRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex w-full items-center gap-2.5 rounded-md px-2.5 py-2.5 text-start text-[13px] transition-colors",
        active
          ? "border border-[color-mix(in_oklab,var(--accent-500)_25%,var(--card))] bg-[color-mix(in_oklab,var(--accent-500)_8%,var(--card))] font-semibold text-[color:var(--accent-600)]"
          : "border border-transparent font-medium text-[color:var(--text-primary)] hover:bg-[color:var(--background-muted)]",
      ].join(" ")}
    >
      <span
        aria-hidden="true"
        className="inline-block h-4 w-4 shrink-0 rounded-full border-[1.5px]"
        style={{
          borderColor: active ? "var(--accent-500)" : "var(--border-strong)",
          background: active ? "var(--accent-500)" : "transparent",
          boxShadow: active ? "inset 0 0 0 3px var(--card)" : "none",
        }}
      />
      {label}
    </button>
  );
}
